import type { ConversationDescription } from "messaging/forums/_views/components/forum-chat-window";
import Forum from "messaging/forums/forum";

/**
 * What each of a work agreement's rooms is called in its Correspondence pane (#6054).
 *
 * The server names the three rooms it opens at hire "All Stakeholders", "Client Team" and "Vendor
 * Team". A reader is a member of the one team room on their own side, so naming each room for what
 * it is names the team tab by the reader's side without asking which side the reader is on.
 */
/** Who reads what the reader sends in the room both teams share. */
const workCorrespondenceAudienceNotice = "Everyone on both teams can see what you send here.";

/** Who reads what the reader sends in a team room: the reader's own team, never the other one. */
const teamCorrespondenceAudienceNotice = "Only your team can see what you send here.";

const descriptionsByForumName: Record<string, ConversationDescription> = {
  // The tab drops "Correspondence": the pane it sits in is already headed Correspondence, and the word
  // is what made the titles wrap. The whole title stays for links, the tab's name and the copy dialog.
  "all stakeholders": { title: "Work Correspondence", shortTitle: "Work", audienceNotice: workCorrespondenceAudienceNotice },
  "client team": {
    title: "Client Team Correspondence",
    shortTitle: "Client team",
    audienceNotice: teamCorrespondenceAudienceNotice,
  },
  "vendor team": {
    title: "Vendor Team Correspondence",
    shortTitle: "Vendor team",
    audienceNotice: teamCorrespondenceAudienceNotice,
  },
};

/**
 * The title of one of the agreement's rooms, and who reads it (#6875). Undefined for any other chat,
 * which keeps its own title and says no audience.
 */
export function describeWorkAgreementConversation(forum: Forum): ConversationDescription | undefined {
  return descriptionsByForumName[forum.name?.toString().trim().toLocaleLowerCase() ?? ""];
}
